<template>
  <div class="add-student">
     
      <v-form ref="studentForm" @submit="submitForm" v-model="valid">
        <v-row class="mx-2">
          <v-col cols="12" md="3">
            <h2 class="mt-4 mb-2 text-left">
              <span v-if="!is_editing">Add</span>
              <span v-else>Edit</span> Student
            </h2>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="2">
         <v-btn
              v-if="is_editing"
              :color="profile.user.disabled ? 'primary' : 'red'"
              class="my-2"
              rounded
              outlined
              block
              @click="showDisableStudentConfirmationDialog = true"
            >
              {{ profile.user.disabled ? 'Enable' : 'Disable' }}
            </v-btn>
          </v-col>
          <v-col v-if="currentUser.privileges.canDeleteStudents" cols="12" md="2">
             <v-btn
              v-if="is_editing"
              color="red"
              class="my-2 white--text"
              rounded
              block
              
              @click="showDeleteStudentConfirmationDialog = true"
            >
              Delete
            </v-btn>
             
          </v-col>
        </v-row>
        
        <h5 class="text-left mx-4 font-weight-regular">* indicates required field</h5>
        <!-- Personal Details -->
        <v-card class="mx-4 my-4 px-4 py-4" tile>
          <v-container>
            <h3 class="text-left mb-4">Personal Details</h3>
            <v-row>
              <v-col cols="12" md="4">
                <v-avatar width="100" height="100">
                  <v-img
                    :src="studentImageFileBase || profile.user.image || endpoints.defaultProfileImage"
                  />
                </v-avatar>
              </v-col>
              <v-col cols="12" md="8">
                <v-file-input @change="studentImageCallback" accept="image/*" label="Student Image"></v-file-input>
              </v-col>

              <v-col cols="12" md="12" class="mb-0">
                <v-text-field
                  v-model="profile.user.full_name"
                  :error="formErrors.fullNameError != null"
                  :error-messages="formErrors.fullNameError"
                  :rules="[rules.required, rules.charsOnly, rules.fullNameLength]"
                  outlined
                  dense
                  placeholder="eg. John David Doe"
                  label="Full Name"
                  class="rounded-input"
                  hide-details="auto"
                  id="fullName"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="profile.user.phone"
                  :error="formErrors.phoneError != null"
                  :error-messages="formErrors.phoneError"
                  :rules="[rules.required, rules.numbersOnly, rules.phoneNumberLength]"
                  outlined
                  dense
                  placeholder="eg. 9999888800"
                  label="Phone Number"
                  class="rounded-input"
                  id="phone"
                  type="number"
                  counter="10"
                  max="10"
                ></v-text-field>
              </v-col>
               <v-col cols="12" md="4">
                 <v-text-field
                  v-model="profile.user.username"
                  :rules="[rules.required, rules.usernameValidation]"
                  counter="20"
                  max="20"
                  outlined
                  dense
                  label="* App Username"
                  placeholder="eg. manishp or 9991091091"
                  hint="This username would be used by students to log into your institution's app"
                  class="rounded-input"
                  id="username"
                  type="text"
                ></v-text-field>
                <v-btn small @click="copyPhoneToUsername" v-if="profile.user.phone && profile.user.phone != profile.user.username">Copy from Phone</v-btn>
              </v-col>
              <v-col cols="12" md="4">
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formattedDate(profile.dob)"
                      append-icon="fas fa-calendar"
                      readonly
                      outlined
                      dense
                      label="Date Of Birth"
                      placeholder="01-01-2000"
                      class="rounded-input"
                      v-bind="attrs"
                      v-on="on"
                      hide-details="auto"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    ref="picker"
                    v-model="profile.dob"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1950-01-01"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu2.save(date)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" md="4">
                <v-select
                  :items="genders"
                  v-model="profile.gender"
                  outlined
                  label="Gender"
                  dense
                  class="rounded-input"
                  item-text="display"
                  item-value="value"
                >
                </v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="profile.nationality"
                  :rules="[rules.length30]"
                  outlined
                  label="Nationality"
                  placeholder="eg. Indian"
                  dense
                  class="rounded-input"
                  hide-details="auto"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="profile.mother_tongue"
                  :rules="[rules.length30]"
                  outlined
                  placeholder="eg. Gujarati"
                  dense
                  label="Mother Tongue"
                  class="rounded-input"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="profile.birth_place"
                  :rules="[rules.length30]"
                  outlined
                  placeholder="eg. Mumbai"
                  label="Birth Place"
                  dense
                  class="rounded-input"
                  hide-details="auto"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="profile.religion"
                  :rules="[rules.length30]"
                  outlined
                  placeholder="eg. Hindu"
                  label="Religion"
                  dense
                  class="rounded-input"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="profile.user.email"
                  outlined
                  dense
                  :rules="[rules.emailOnly]"
                  label="Email"
                  placeholder="eg. abc@xyz.com"
                  class="rounded-input"
                  hide-details="auto"
                ></v-text-field>
              </v-col>

              <v-row class="mx-1 my-2">
                <v-col cols="12" md="4">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="profile.aadhar"
                        label="Aadhar Number"
                        outlined
                        dense
                        placeholder="eg. 123456789123"
                        class="rounded-input"
                        hide-details="auto"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="profile.caste"
                        label="Caste"
                        outlined
                        dense
                        placeholder="eg. OBC"
                        class="rounded-input"
                        hide-details="auto"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                </v-col>
                <v-col cols="12" md="8">
                  <v-textarea
                    name="input-7-1"
                    placeholder="eg. Akshya Nagar 1st Block 1st Cross, Rammurthy nagar, Bangalore-560016"
                    label="Address"
                    outlined
                    v-model="profile.address"
                    class="rounded-input"
                    dense
                    rows="3"
                    hide-details="auto"
                  ></v-textarea>
                </v-col>
              </v-row>


            </v-row>
          </v-container>
        </v-card>
        <!-- Academic details -->
        <v-card class="mx-4 my-4 px-4 py-4" tile>
          <v-container>
            <h3 class="text-left mb-4">Academic Details</h3>
            <v-row>
              <v-col cols="12" md="4" class="mb-0">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formattedDate(profile.date_of_admission)"
                      append-icon="fas fa-calendar"
                      readonly
                      outlined
                      dense
                      placeholder="01-01-2015"
                      label="Date of Admission"
                      class="rounded-input"
                      hide-details="auto"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="profile.date_of_admission" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <!-- Below col removed when removed classroom -->
              <!-- <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="profile.user.room"
                  :items="rooms"
                  :error="formErrors.roomError != null"
                  :error-messages="formErrors.roomError"
                  label="* Classroom"
                  item-text="sections"
                  return-object
                  :rules="[rules.required]"
                  class="rounded-input"
                  outlined
                  id="room"
                  dense
                  hide-details="auto"
                >
                 
                </v-autocomplete>
              </v-col> -->

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="profile.admission_class"
                  :rules="[rules.length30]"
                  outlined
                  placeholder="eg. Nursery"
                  label="Admission Class"
                  dense
                  class="rounded-input"
                  hide-details="auto"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="profile.roll_number"
                  required
                  outlined
                  dense
                  placeholder="eg. 111111"
                  label="Roll Number"
                  class="rounded-input"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="profile.gr_no"
                  :rules="[rules.length10]"
                  outlined
                  dense
                  placeholder="eg. A-1411"
                  label="GR No."
                  class="rounded-input"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- classroom history -->
            <v-row>
              <v-col cols="12" md="9" class="my-4">
                <h4 class="text-left">
                  Classroom Details <span class="red--text">*</span>
                </h4>
              </v-col>
              <v-col cols="12" md="3">
                <v-btn color="primary" small @click="initAddClassroom">Assign Classroom</v-btn>
              </v-col> 
            </v-row>
            <v-data-table
              :headers="classroomHistoryHeaders"
              :items="profile.previous_rooms"
              disable-pagination
              hide-default-footer
              class="elevation-1"
            >
              <!-- <template v-slot:item.fee_account="{ item }">
                <span v-if="item.fee_account">
                  <router-link>
                    Fee Account
                  </router-link>
                </span>
                <span v-else>-</span>
              </template> -->
              <template slot="no-data">
                <span>-</span>
              </template>
              <template slot="body.append" v-if="profile.user.room">
                <tr class="">
                  <td class="text-left green--text">{{ profile.user.room.sections }} (Current)</td>
                  <!-- <td>Fee Account</td> -->
                  <td class="green--text">{{ profile.user.room.session.title }}</td>
                  <td>
                    <v-icon
                      class="mr-2"
                      color="red"
                      @click="deletingClassroom=Helper.clone(profile.user.room);showDeleteClassroomDialog=true;"
                    >
                      mdi-delete

                    </v-icon>
                  </td>
                </tr>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon
                  class="mr-2"
                  color="red"
                  @click="deletingClassroom=Helper.clone(item);showDeleteClassroomDialog=true;"
                >
                  mdi-delete

                </v-icon>
              </template>  
            </v-data-table>
          </v-container>

        </v-card>
        <!-- Parents Details -->
        <v-card class="mx-4 my-4 px-4 py-4" tile>
          <v-container>
            <h3 class="text-left mb-4">Parent's Details</h3>
            <v-row>
              <v-col cols="12" md="6" class="mb-0">
                <v-text-field
                  v-model="profile.fathers_name"
                  required
                  :rules="[rules.charsOnly, rules.nameLength]"
                  outlined
                  dense
                  placeholder="David Doe"
                  label="Father's Name"
                  class="rounded-input"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="profile.mothers_name"
                  required
                  outlined
                  :rules="[rules.charsOnly, rules.nameLength]"
                  dense
                  placeholder="Jane Doe"
                  label="Mother's Name"
                  class="rounded-input"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="profile.fathers_phone"
                  required
                  max="10"
                  counter="10"
                  :rules="[rules.numbersOnly, rules.phoneNumberLength]"
                  outlined
                  dense
                  placeholder="eg. 9999888800"
                  label="Father's Phone"
                  class="rounded-input"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="profile.mothers_phone"
                  required
                  max="10"
                  counter="10"
                  :rules="[rules.numbersOnly, rules.phoneNumberLength]"
                  outlined
                  dense
                  placeholder="eg. 9999888800"
                  label="Mother's Phone"
                  class="rounded-input"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="profile.parents_email"
                  required
                  :rules="[rules.emailOnly]"
                  outlined
                  dense
                  placeholder="eg. abc@xyz.com"
                  label="Parent's Email"
                  class="rounded-input"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <!-- Other details if available -->
        <v-card class="mx-4 my-4 px-4 py-4" tile v-if="profile.other_details">
          <v-container>
            <h3 class="text-left mb-4">Other Details</h3>
            <v-row>
              <v-col
                cols="12"
                md="4"
                v-for="other_details_item in profile.other_details"
                :key="other_details_item.id"
              >
                <v-text-field
                  v-model="other_details_item.value"
                  required
                  outlined
                  dense
                  class="rounded-input"
                  :label="other_details_item.custom_attr.label"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card>

        <!-- User docs if available -->
        <v-card class="mx-4 my-4 px-4 py-4" tile v-if="profile.user_documents">
          <v-container>
            <h3 class="text-left mb-4">User Documents</h3>
            <v-row v-for="document in profile.user_documents" :key="document.id">
              <v-col
                cols="12"
                md="9"
              >
              <v-file-input
                dense
                color="primary"
                counter
                :label="document.doc_type.name"
                @change="onDocChange($event, document.doc_type)"
                prepend-icon="mdi-paperclip"
                :hint="document.file_name? `Uploaded File : ${document.file_name}` : '' "
                persistent-hint
                outlined
                class="rounded-input"
                :show-size="1000"
              >
                <!-- <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 2" color="primary" dark label small>
                    {{ text }}
                  </v-chip>
                  <span
                    v-else-if="index === 2"
                    class="overline grey--text text--darken-3 mx-2"
                  >
                    +{{ files.length - 2 }} File(s)
                  </span>
                </template> -->
              </v-file-input>
                
              </v-col>
              <v-col cols="12" md="3">
                <v-btn class="ma-0" text color="primary" outlined dense :href="document.document_file" target="_blank" :disabled="document.document_file == null">
                  View Document</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <v-row  v-if="is_editing"> 
          <v-col cols="12" md="3">
            <v-btn color="primary" :to="{name:'FeeSettingsCategory',params:{searchUsername:this.profile.user.username}}">
              Fee Category
            </v-btn>
            <v-tooltip v-if="JSON.parse(currentInstitution.erp_features).includes(4)" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            class="mx-2 my-2"
                            >
                            mdi-help-circle
                          </v-icon>
                        </template>
                        <span>Assign or Change Fee Category to student.</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <div class="text-right mx-4 my-4">
          <v-btn
            class="mr-4"
            color="red"
            :to="{ name: 'Students' }"
            v-if="!is_editing"
            rounded
            outlined
          >Cancel</v-btn>
          <v-btn
            class="mr-4"
            color="red"
            :to="{ name: 'StudentDetails', params: { id: this.profile.user.id }  }"
            v-else
            rounded
            outlined
          >Cancel</v-btn>
          <v-btn color="primary" type="submit" :disabled="isLoading || !valid" rounded>Submit</v-btn>
        </div>
      </v-form>
      <v-snackbar v-model="snackbar.visible">
        <span>{{ snackbar.text }}</span>
        <template>
          <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
        </template>
      </v-snackbar>

      <!-- <delete-confirmation-dialog 
        title="Are you sure you want to delete this student?"
        description="This student will no longer be visible in the system"
        successText="Proceed"
        @deleteObject="softDeleteStudent"
        failureText="Cancel"
        @failureCallback="showDeleteStudentConfirmationDialog = false"
        :visible="showDeleteStudentConfirmationDialog"
      /> -->

      <!-- Select current or all records of student while deleting -->
      <ConfirmationDialog
        title="Delete Student?"
        description="Please select 'Delete Current Records' if you want to preserve the records from previous and/or future year(s). Alternatively you can select 'Delete All Records' if you want to delete the student permanently. Please proceed with caution."
        successText="Delete"
        @successCallback="deleteStudent"
        failureText="Cancel"        
        @failureCallback="showDeleteStudentConfirmationDialog = false; $refs.deleteStudentForm.reset()"
        :visible="showDeleteStudentConfirmationDialog"
        :disableSuccessButton="!deleteStudentForm"
      >
        <div class="mx-6">
          <v-form v-model="deleteStudentForm" ref="deleteStudentForm">
            <v-radio-group v-model="deleteRecords" :rules="[ rules.required ]">
              <v-radio value="current">
                <template v-slot:label>
                  <p class="success--text mb-0">Delete Current Records ({{profile.user.room ? profile.user.room.session.title : "-"}})</p>

                </template>
              </v-radio>
              <v-radio value="all">
                <template v-slot:label>
                  <p class="red--text mb-0">Delete All Records</p>
                </template>
              </v-radio>
            </v-radio-group>
          </v-form> 
        </div>
        
      </ConfirmationDialog>

<!-- Disable Dialog box -->
      <ConfirmationDialog
        :title="profile.user.disabled ? 'Enable Student?' : 'Disable Student?'"
        :description="`Are you sure you want to ${ profile.user.disabled ? 'enable' : 'disable' } this student? This will ${ profile.user.disabled ? 'allow' : 'restrict' } the student's login in the app as well.`"
        :successText="profile.user.disabled ? 'Enable' : 'Disable'"
        @successCallback="disableStudent"
        failureText="Cancel"
        @failureCallback="showDisableStudentConfirmationDialog = false;"
        :visible="showDisableStudentConfirmationDialog"
      >
      </ConfirmationDialog>

      <!-- Delete Confirmation box -->
      <DeleteConfirmationDialog
        title="Delete Classroom Record"
        description="Are you sure you want to delete this classroom record from student's academic history. The associated fee account will also be disabled. To restore the academic and fee accounts for this year, you will have to restore the student from 'Deleted Records' section. You can only restore such accounts for any academic year until another classroom is not set (overwriten). Proceed with caution. This action will only be saved when you click submit."
        confirmationButtonText="Delete"
        failureText="Cancel"
        @deleteObject="(confirm) =>  confirm ?  deleteClassroom() : showDeleteClassroomDialog = false"
        :visible="showDeleteClassroomDialog"
        serious
      >
      </DeleteConfirmationDialog>

      <ConfirmationDialog
        :title="'Select Payment Adjustment Option'"
        :description="'Refund Payment or Keep Transactions'"
        successText="Refund Payments"
        @successCallback="refundConfirmationDialogVisible = true;"
        failureText="Keep Transactions"
        @failureCallback="softDeleteFeeAccount"
        :visible="selectOptionforPaymentAdjustmentDialogVisible"
      >
      </ConfirmationDialog>


      <!-- amount refund -->
      <ConfirmationDialog
        title="Are you sure you want to change this student's Classroom?"
        :description="`This account has a total amount of ${currencyFormat(amountNeedsToBeAdjusted)} that needs to be adjusted before changing the Classroom of the Student`"
        successText="Proceed"
        @successCallback="refundPaidAndChangeClassroom()"
        failureText="Cancel"
        @failureCallback="closeDialog"
        :visible="refundConfirmationDialogVisible"
      >
        <slot>
         <v-form v-model="refundFormValid" :ref="refundFormValid">
            <v-text-field
              v-model="refundReceiptNumber"
              class="rounded-input mx-5"
              outlined
              dense
              :rules="[rules.required]"
              placeholder="Receipt No."
            />
            <v-text-field
              v-model="refundRemarks"
              class="rounded-input mx-5"
              outlined
              dense
              placeholder="Remarks (Optional)"
              hint="This will be displayed in the refund receipt."
            />
          </v-form>
        </slot>
      </ConfirmationDialog>

      <!-- Add Classroom Dialog -->
      <v-dialog
        v-model="showAddClassroomDialog"
        max-width="500px"
      >
        <v-card>
          <v-form v-model="addClassroomForm.valid" ref="addClassroomForm">
          <v-card-title>
            <h4>Add Classroom</h4>
          </v-card-title>
          <v-card-subtitle>
            <p class="text-left mb-0">Select an academic year and classroom to add in classroom history for this student.</p>
          </v-card-subtitle>
          <v-card-text>
            <v-container v-if="academicSessions">
              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="addClassroomForm.session"
                    :items="academicSessions"
                    item-text="title"
                    item-value="id"
                    outlined
                    class="rounded-input"
                    label="Academic Session"
                    dense
                    :item-disabled="checkRoomExistsInHistory"
                    :rules="[ rules.required ]"
                    @change="addClassroomForm.room = null"
                    hide-details="auto"
                  >
                    <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <v-list-item-title>
                            <span :class="item.active ? 'primary--text' : null ">{{ item.title }} {{ item.active ? ' ( Current )' : null }}</span>
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{ checkRoomExistsInHistory(item) ? 'Assigned' : 'Unassigned' }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                    </template>
                  </v-select>
                </v-col> 
                <v-col cols="12">
                  <v-select
                    v-model="addClassroomForm.room"
                    v-if="addClassroomForm.session"
                    :items="academicSessions.find(session => session.id == addClassroomForm.session).session_rooms"
                    item-text="sections"
                    item-value="id"
                    outlined
                    class="rounded-input"
                    label="Classroom"
                    :rules="[ rules.required ]"
                    dense
                    hide-details="auto"
                  ></v-select>
                </v-col> 
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="showAddClassroomDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary darken-1"
            text
            :disabled="!addClassroomForm.valid"
            @click="addClassroomToClassroomHistory"
          >
            Save
          </v-btn>
        </v-card-actions>
          </v-form>
          
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import api from "@api/index";
import endpoints from "@api/repository";
import Helper from "@utils/misc";
import moment from 'moment';
import ConfirmationDialog from '@components/widgets/dialogs/ConfirmationDialog';
import DeleteConfirmationDialog from '@components/widgets/dialogs/DeleteConfirmationDialog';

// import DeleteConfirmationDialog from '../../components/widgets/dialogs/DeleteConfirmationDialog.vue';

export default {
  name: "AddEditStudent",
  data() {
    return {
      rules: {
        required: (v) => !!v || "Required",
        fullNameLength: (v) => !v || v?.length<=70 || "Too Long",
        nameLength: (v) => !v || v?.length<=40 || "Max length is 40",
        charsOnly: (v) => !/[^a-zA-Z. ]/.test(v) || "Invalid",
        usernameValidation: (v) => !v || !/[^a-zA-Z0-9.]/.test(v) || "Invalid",
        numbersOnly: (v) => !v || !/[^0-9]/.test(v) || "Invalid",
        phoneNumberLength: (v) => !v || v?.length == 10 || "Should be 10 Digits",
        emailOnly: (v) => !v ||
          /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/.test(
            v
          ) || "Not a valid email",
        length30 : (v) => !v || v?.length<=30 || "Too long",
        length10: (v) => !v || v?.length<=10 || "Max 10 digits",
      },
      endpoints: endpoints,
      studentImageFileBase: null,
      Helper: Helper,
      moment: moment,
      refundReceiptNumber: null,
      snackbar: {
        visible: false,
        text: "",
      },
      menu: false,
      menu2: false,
      date: null,
      is_editing: false,
      genders: [
        {
          display: 'Male',
          value: 'M',
        },
        {
          display: 'Female',
          value: 'F',
        },
        {
          display: 'Other',
          value: 'O',
        },
      ],
      profile: {
        user: {
          id: null,
          phone: null,
          username: null,
          full_name: null,
          // first_name: null,
          // last_name: null,
          email: null,
          image: null,
          institution: null,
          fcm_token: null,
          room: null,
          is_student: true,
          is_faculty: false,
          disabled: false,
          is_admin: false,
        },
        previous_rooms: [],
        middle_name: null,
        dob: null,
        address: null,
        date_of_admission: null,
        roll_number: null,
        gr_no: null,
        fathers_name: null,
        mothers_name: null,
        fathers_phone: null,
        mothers_phone: null,
        parents_email: null,
        gender: null,
        nationality: null,
        mother_tongue: null,
        birth_place: null,
        religion: null,
        admission_class: null,
        other_details: [],
        user_documents: [],
      },
      documents: {},
      rooms: [],
      valid: true,
      showDeleteStudentConfirmationDialog: false,
      showDisableStudentConfirmationDialog:false,
      deleteStudentForm: false,
      deleteRecords: null,
      formErrors: {
        firstNameError: null,
        lastNameError: null,
        phoneError: null,
        emailError: null,
        roomError: null,
      },
      refundConfirmationDialogVisible: false,
      selectOptionforPaymentAdjustmentDialogVisible: false,
      refundRemarks: null,
      refundFormValid: true,
      amountNeedsToBeAdjusted: null,
      academicSessions: null,
      showAddClassroomDialog : false,
      addClassroomForm : {
        session: null,
        room: null,
        valid: false,
      },
      classroomHistoryHeaders: [
        {
          text: 'Classroom',
          align: 'start',
          sortable: false,
          value: 'sections',
        },
        // {
        //   text: 'Fee Account',
        //   align: 'center',
        //   sortable: false,
        //   value: 'fee_account',
        // },
        {
          text: 'Academic Year',
          align: 'center',
          sortable: false,
          value: 'session.title',
        },
        {
          text: 'Actions',
          align: 'center',
          sortable: false,
          value: 'actions',
        }
      ],
      classroomHistory: [],
      showDeleteClassroomDialog: false,
      deletingClassroom: null,
    };
  },
  components: {
    ConfirmationDialog,
    DeleteConfirmationDialog,
  },

  computed: {
    ...mapGetters(["accessToken", "currentUser", "isLoading","currentInstitution"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    checkRoomExistsInHistory(item){
      let exists = false;
      // check in previous rooms
      this.profile.previous_rooms.forEach(room => {
        if(room.session.id == item.id){
          exists = true;
        }
      });
      // check in current room
      if(this.profile.user.room && this.profile.user.room.session.id == item.id){
        exists=true;
      }
      return exists ? true : false
    },

    deleteClassroom(){
      // check current classroom
      if(this.profile.user.room && this.deletingClassroom.id == this.profile.user.room.id){
        this.profile.user.room = null;
      }
      else{
        this.profile.previous_rooms = this.profile.previous_rooms.filter(room => room.id != this.deletingClassroom.id)
      }
      this.deletingClassroom = null;
      this.showDeleteClassroomDialog = false;

    },

    currencyFormat(amt) {
      return Helper.currencyFormat(amt);
    },

    async onDocChange(payload, doctype){
      // this.setLoading(true);
      const file = payload; 
      if(file){
        this.documents[doctype.id] = await Helper.toBase64(file);
      }
      else{
        delete this.documents[doctype.id]
      }
      // this.setLoading(false); 
    },

    // executed when student image is added
    async studentImageCallback(image) {
      // console.log("studentImageCallback");
      if (!image) {
        this.studentImageFileBase = null;
      }
      this.studentImageFileBase = await Helper.toBase64(image);
    },

    async getRooms() {
      this.setLoading(true);
      var response;
      var url = endpoints.getRooms;

      response = await api.handleApi({
        apiEssentials: this.apiEssentials,
        url: url,
        responseVar: response,
      });

      if (response instanceof Error) {
        this.setLoading(false);
        this.snackbar.text = "Error retrieving rooms";
        this.snackbar.visible = true;
        return;
      }
      this.rooms = response;

      this.setLoading(false);
    },

    async copyPhoneToUsername() {
      this.profile.user.username = this.profile.user.phone;
    },

    async getAllAcademicSessions(){
      this.academicSessions = await api.call(this.apiEssentials, endpoints.academicSessionsViewSet)
    },

    async initAddClassroom(){
      if(!this.academicSessions)
        await this.getAllAcademicSessions();
      this.showAddClassroomDialog = true;
    },

    addClassroomToClassroomHistory(){
      let session = Helper.clone(this.academicSessions.find(s => s.id == this.addClassroomForm.session))
      let new_room = Helper.clone(session.session_rooms.find(room => room.id == this.addClassroomForm.room))
      delete session.session_rooms
      new_room.session = session
      if(session.active){
        this.profile.user.room = Helper.clone(new_room)
      }else{
        this.profile.previous_rooms.push(new_room)
      }
      this.addClassroomForm.session = null;
      this.addClassroomForm.room = null;
      this.showAddClassroomDialog = false;
    },

    async getStudentAttributes() {
      this.setLoading(true);
      var response;
      var url = endpoints.getStudentAttributes;

      response = await api.handleApi({
        apiEssentials: this.apiEssentials,
        url: url,
        responseVar: response,
      });
      console.log(response)
      if (response instanceof Error) {
        this.setLoading(false);
        this.snackbar.text = "Problem retreiving other details";
        this.snackbar.visible = true;
        return;
      } else {
        response.map((custom_attr) => {
          this.profile.other_details.push({
            custom_attr: custom_attr,
            value: null,
          });
        });
      }
      this.setLoading(false);
    },

    async getStudentDocumentTypes(){
      var response = await api.call(this.apiEssentials,endpoints.userDocumentTypes)
      if(response instanceof Error){
        this.setLoading(false);
        this.snackbar.text = "Problem retreiving document types";
        this.snackbar.visible = true;
        return
      }
      response.map((document) => {
        this.profile.user_documents.push({
          doc_type: document,
          filename: null,
        })
      })
    },

    async getStudentDetails() {
      this.setLoading(true);
      var response;
      var url = endpoints.getStudentDetails + `${this.$route.params.id}/`;

      response = await api.handleApi({
        apiEssentials: this.apiEssentials,
        url: url,
        responseVar: response,
      });

      if (response instanceof Error) {
        this.setLoading(false);
        this.snackbar.text = "There was a server error. Please, try again!";
        this.snackbar.visible = true;
        return;
      } else {
        this.profile = response;
      }
      this.setLoading(false);
    },

    // async softDeleteStudent(confirm) {
    //   this.showDeleteStudentConfirmationDialog = false;
    //   if(!confirm) return;
    //   var url = endpoints.softDeleteStudent + this.$route.params.id + '/';
    //   var response = await api.call(this.apiEssentials, url, api.Methods.DELETE);
    //   if(response) {
    //     this.snackbar.text = "Student was successfully deleted!";
    //     this.snackbar.color = "green";
    //     this.snackbar.visible = true;
    //     var self = this;
    //     setTimeout(() => self.$router.push({ name: 'Students' }), 2000);
    //   }
    // },
    async disableStudent(){
       this.showDisableStudentConfirmationDialog = false;
        var url =endpoints.disableStudent;
        var body= {"student_id":this.profile.user.id }
        await api.call(this.apiEssentials,url,api.Methods.POST,body)
        this.$router.push({ name: 'StudentDetails', params: { id: this.profile.user.id } })
        
    },

    async softDeleteFeeAccount(){
      this.selectOptionforPaymentAdjustmentDialogVisible = false;
      var url = endpoints.softDeleteFeeAccount;
      var post_body = {
        student_id : this.profile.user.id,
        room_id : this.profile.user.room.id
      }
      var response = await api.call(this.apiEssentials, url, api.Methods.POST, post_body);
      if(response) {
        this.snackbar.text = "Fee Account Deleted successfully deleted!";
        // this.snackbar.color = "green";
        this.snackbar.visible = true;
        this.submitForm();
      }
    },

    async deleteStudent(){
      this.showDeleteStudentConfirmationDialog = false;
      var url = null;
      if(this.deleteRecords == 'current'){
        url = endpoints.deleteCurrentStudentRecord + `${this.profile.user.id}/`;
      }
      else if(this.deleteRecords == 'all'){
        url = endpoints.softDeleteStudent + `${this.profile.user.id}/`;
      }
      else{
        return
      }
      var response = await api.call(this.apiEssentials, url, api.Methods.DELETE);
      if(response) {
        this.snackbar.text = "Student Record Deleted successfully deleted!";
        // this.snackbar.color = "green";
        this.snackbar.visible = true;
        var self = this;
        setTimeout(() => self.$router.push({ name: 'Students' }), 2000);
      }
      
    },

    validateFields() {
      Object.keys(this.formErrors).forEach((v) => (this.formErrors[v] = null));
      if (
        this.profile.user.phone == "" ||
        this.profile.user.phone == null
      ) {
        this.formErrors.phoneError = "This field is required";
        this.$vuetify.goTo("#phone");
        return false;
      }
      if (
        this.profile.user.full_name == "" ||
        this.profile.user.full_name == null
      ) {
        this.formErrors.fullNameError = "This field is required";
        this.$vuetify.goTo("#fullName");
        return false;
      }
      if (
        this.profile.user.username == "" ||
        this.profile.user.username == null
      ) {
        this.formErrors.usernameError = "This field is required";
        this.$vuetify.goTo("#username");
        return false;
      }
      // if (this.profile.user.phone == "" || this.profile.user.phone == null) {
        // this.formErrors.phoneError = "Phone number is required";
        // this.$vuetify.goTo("#phone");
        // return false;
      // }
      // below 4 lines commented when removed classroom  
      // if (this.profile.user.room == null) {
      //   this.formErrors.roomError = "Please select a room";
      //   this.$vuetify.goTo("#room");
      //   return false;
      // }
      if(!this.profile.user.room && this.profile.previous_rooms.length < 1){
        this.snackbar.text = "Please add atleast one classroom."
        this.snackbar.visible = true;
        return false;
      }
      return true;
    },

    formattedDate(date) {
      if (!date) return "";
      return moment(date).format("D MMM YYYY");
    },

    async submitForm(e) {
      if(e) e.preventDefault();
      // validateFields
      if (!this.validateFields() || !this.valid) return;
      this.setLoading(true);

      // edit_student request
      var response;

      this.profile.user.image = this.studentImageFileBase; //check for image

      var post_body = {
        is_editing: this.is_editing,
        profile: this.profile,
        has_documents: ((Object.keys(this.documents)).length > 0),
        documents: this.documents,
      }

      response = await api.handleApi({
        apiEssentials: this.apiEssentials,
        url: endpoints.createOrEditStudent,
        responseVar: response,
        method: api.Methods.POST, //POST
        body: post_body,
      });

      if(response == null) return;

      if (response instanceof Error) {
        this.setLoading(false);
        this.snackbar.text = "There was a server error. Please, try again!";
        this.snackbar.visible = true;
        return;
      }

      // this.profile = response;qu

      if (this.is_editing) {
        // this.profile = response;
        this.$router.push({
          name: "StudentDetails",
          params: { id: this.profile.user.id },
        });
        return;
      } else {
        if(this.profile.user.room)
          this.$router.push({ name: "Students", params: { searchPhoneNumber: this.profile.user.phone } });
        else{
          this.$router.push({ name: "Students", params: { searchPhoneNumber: this.profile.user.phone, filterAcademicYear: this.profile.previous_rooms.pop().session.id } });

        }
      }
      this.setLoading(false);
    },

    async closeDialog() {
      this.refundConfirmationDialogVisible = false;
      this.amountNeedsToBeAdjusted = null;
      this.refundReceiptNumber = null;
      this.refundRemarks = null;
      
    },

    async refundPaidAndChangeClassroom() {
        if (!this.refundReceiptNumber) {
        this.snackbar.text = "Invalid Receipt Number";
        this.snackbar.visible = false;
        return;
      }
      var receipt_number = this.refundReceiptNumber;
      var remarks = this.refundRemarks;
      this.closeDialog()
      var body = {
        student_id: this.profile.user.id,
          receipt_number: receipt_number,
        remarks: remarks,
      }
      var response = await api.call(this.apiEssentials, endpoints.refundFeesForChangingRoom, api.Methods.POST, body);
      if(response == true){
        this.snackbar.text = "Refund receipt generated and visible in the student's fee details";
        this.snackbar.visible = true;
        // if everything's good, submit
        if (this.validateFields() && this.valid) this.submitForm();
      }
    },

    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
        if(err.response.status == 406){
          this.amountNeedsToBeAdjusted = err.response.data.amount;
          this.selectOptionforPaymentAdjustmentDialogVisible =true;
        }

        else if (err.response.status == 409) {
          this.snackbar.text = "Username should be unique";
          this.snackbar.visible = true;
        }
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },
  },
  created() {
    // removed since classroom removed
    // this.getRooms();
    // check if editing
    if (this.$route.params.id) {
      this.is_editing = true;
      this.getStudentDetails();
    } else {
      this.getStudentAttributes();
      this.getStudentDocumentTypes()
    }
  },
};
</script>

<style scoped>
.text-white {
  color: white !important;
}
.rounded-input {
  border-radius: 12px !important;
}
span.required::after {
  content: "*";
  font-size: 18px;
  color: red;
}
</style>

